import { render, staticRenderFns } from "./staffArtsMore.vue?vue&type=template&id=3cb15acb&scoped=true"
import script from "./staffArtsMore.vue?vue&type=script&lang=js"
export * from "./staffArtsMore.vue?vue&type=script&lang=js"
import style0 from "./staffArtsMore.vue?vue&type=style&index=0&id=3cb15acb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb15acb",
  null
  
)

export default component.exports